export const makeUpdateTagSuccessMessage = name => `Tag ${name} updated!`;
export const makeCreateTagSuccessMessage = name => `Tag ${name} created!`;
export const makeDeleteTagSuccessMessage = name => `Tag ${name} has been deleted and all affected issues have been updated!`;
